<template>
	<div class="content">
		<arrorImg  bg="white"></arrorImg>
		<navBar title="抽奖活动" color="#ffffff"></navBar>
		<div class="contaner-box">
			<img class="play-title" src="../../../static/play_title.png"  alt="">
			<div class="current_money"><span>当前可用书币</span><span style="color:#ffc750;">{{enableCurrency}}</span></div>
			<div class="play_tips">{{recordCurrency}}书币抽一次，每日可免费抽{{recordNum}}次</div>
			<img class="win-record" @click="routeWin" src="../../../static/win_record.png" alt="">
			<div class="record-box">
				<div class="record-list">
					<div class="record-item" :class="'award' + index" v-for="(item,index) in list" :key="index">
						<img v-if="recordIndex==index" src="../../../static/yellow-bg.png" alt="">
						<div class="record-item-child">
							<img :src="item.prizePicture" alt="">
							<span>{{item.prizeName}}</span>
							<div v-if="recordIndex!=index" class="record-mask"></div>
						</div>
					</div>
					<div class="choost-btn record-btn" @click="start">
						<div class="record-btntext" v-if="residueNum>0">
							<span style="font-size:24px;color:#FFDB00;margin-top:4px;font-weight:bold;">免费抽</span>
							<span>{{residueNum}}次</span>
						</div>
						<div class="record-btntext" v-else>
							<span>{{recordCurrency}}书币</span>
							<span>继续抽</span>
						</div>
					</div>
				</div>
			</div>
			<span class="tips">中奖书币有效期为{{dictValue}}天</span>
		</div>

	 <div class="record-maskdiv" v-if="showRecord" >
	      <div>
	        <span class="title-mask">恭喜中奖</span>
	        <span class="title-tips">抽中{{award.name}}</span>
			<img  @click="closeRecord" src="../../../static/happy-icon.png" alt="">
	      </div>
	    </div>
	</div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	import arrorImg from "../../components/arrow-img.vue";
	import navBar from '../components/navbar.vue'
	export default {
		components: {
			arrorImg,
			navBar
		},
		data() {
			return {
				enableCurrency: 0,
				recordCurrency: 0, //多少书币抽奖一次
				recordNum: 0, //免费抽奖次数
				list: [],
				showRecord: false,
				residueNum: 0, //剩余次数
				recordIndex: -1,
				timer: null,
				speed: 200, // 时间->速度
				diff: 6, // 基数
				award: {}, // 抽中的奖品
				time: 0, // 当前时间戳
				isStart: true,
				prizeType: 3,
				singnIndex: 0,
				clickIndex: 0,
				isEntranceData:'',
				dictValue:0,
				pageType:''
			}
		},
		mounted() {
			if(this.$route.query.isEntranceData){
				this.isEntranceData=this.$route.query.isEntranceData;
			}
			this.pageType=this.$route.query.pageType;
			var openid =  this.$base.getStorage('openid')
			var isWxAuthorized =  this.$base.getStorage('isWxAuthorized');
			this.enableCurrency= this.$base.getStorage('currency')
			  var city = this.$base.getStorage("city");
			if (!openid) { //静默登录手动登录
				// #ifdef H5
				// #endif
			} else if(isWxAuthorized==0&&city==1&&openid&&!this.$store.state.user.isSNS){
				 this.$base.setStorage('isSNS',true)
				this.$store.state.user.isSNS=true;
				this.$commonApi.snsapiUserinfo();
				this.geLuckDrawInfo();
				
			} else {
				this.geLuckDrawInfo();
			}
			this.$commonApi.share();

		},
		onShow() {
			 let pages = getCurrentPages(); // 获取当前打开过的页面路由数组
			 if (pages.length >= 2) {
			 	let prevPage = pages[pages.length - 2]; //上一页页面实例
			 	if (this.pageType == 'bookMine' ) { //判断页面是否是目录或书架进入， 返回刷新
			 		prevPage.isReload = true;
			 		console.log(prevPage.isReload)
			 	}
			 }
		},
		methods: {
			closeRecord(){
				this.showRecord=false;
			},
			getCurrencyValidity(){
				this.$api.getCurrencyValidity().then(res=>{
					if(res.status==1){
						this.dictValue=res.data.lotteryCurrency.dictValue;
					}
				  })
				},
			insertPageAccessData() {
				var prevPage = "";
      if (this.pageType === "bookCurrency") {
        prevPage = "书币";
      }else if (this.pageType === "bookCharge") {
        prevPage = "充值中心";
      } else if (this.pageType === "bookCity") {
        prevPage = "书城";
      } 
				   var params = {
				       pageName: '抽奖活动',
				       pageRemark: "上级页面："+prevPage,
					   isEntranceData:this.isEntranceData
				     }
				this.$api.insertPageAccessData(params).then(res => {
			
				})
			},
			geLuckDrawInfo() {
				this.$api.geLuckDrawInfo().then(res => {
					if (res.status == 1) {
						this.list = res.data.luckDrawInfoList;
						this.residueNum = res.data.surplusTimes;
						this.recordCurrency = res.data.luckCurrery;
						this.recordNum = res.data.luckTimes;
						this.insertPageAccessData();
						this.getCurrencyValidity();
					}
				})
			},
			getUserCurrency() {
				this.$api.getUserCurrency().then(res => {
					if (res.status == 1) {
						this.enableCurrency = res.data;
						 this.$base.setStorage('currency', res.data)
					}
				})
			},
			routeWin(){
				this.$router.push({
					path:'/pages/winRecord/index',
				})
			},
			start() {
				// 开始抽奖
				if (this.isStart) {
					if (this.residueNum > 0 || this.recordCurrency <= this
						.enableCurrency) { //判断用户抽奖次数是否大于0次  当前书币是否大于抽奖消耗的书币
						this.getLottery();
					} else {
						let now = new Date().valueOf();
						if ((now - this.clickIndex) > 5000) {
							this.clickIndex = now;
							Toast({
								message: "书币不足，请充值后继续抽奖",
							})
						}
					}
				} else {
					let now = new Date().valueOf();
					if ((now - this.singnIndex) > 5000) {
						this.singnIndex = now;
						Toast({
							message: "抽奖进行中，请稍后"
						})
					}
				}
			},
			// 调接口获取奖品
			getLottery() {
				this.$api.lottery().then(res => {
					if (res.status === 1) {
						this.isStart = false;
						this.award.id = res.data.id;
						this.award.name = res.data.prizeName;
						console.log(this.award.id)
						this.prizeType = res.data.prizeType;
						this.time = Date.now();
						this.speed = 200;
						this.diff = 6;
						this.recordIndex = -1;
						if (this.residueNum > 0) {
							this.residueNum--;
						}
						this.move();
					} else {
						Toast({
							message: res.message
						})

					}
				})

			},
			closeRecord() {
				this.showRecord = false;
			},
			move() { //抽奖
				this.timer = setTimeout(() => {
					this.recordIndex++;
					console.log((Date.now() - this.time))
					console.log('speed.......' + this.speed)
					if (this.recordIndex > 7) {
						this.recordIndex = 0;
					}
					if (this.award.id && ((Date.now() - this.time) / 1000 > 2)) {
						this.speed += this.diff; // 转动减速
						if (
							(Date.now() - this.time) / 1000 > 4 &&
							this.award.id == this.list[this.recordIndex].id
						) {
							clearTimeout(this.timer);
							if (this.prizeType == 3) {
								Toast({
									message: '未中奖，再抽一次试试',
								})
							} else {
								this.showRecord = true;
							}
							this.isStart = true;
							this.getUserCurrency();
							console.log(`恭喜中奖${this.award.name}元`)
							console.log(`恭喜中奖${this.award.id}元`)
							return;
						}
					} else {
						// 若抽中的奖品不存在，则加速转动
						this.speed -= this.diff;
					}
					this.move();
				}, this.speed);
			}
		}
	}
</script>

<style scoped>
body,html,#app{
  height:100%;
}
	.record-maskdiv {
	  position: fixed;
	  left: 0px;
	  top: 0px;
	  background-color: rgba(0, 0, 0, 0.5);
	  align-items: center;
	  justify-content: center;
	  width: 100%;
	  height: 100%;
	  z-index: 999;
	}
	.record-maskdiv > div {
	  width: 240px;
	  height: 176px;
	  position: absolute;
	  top: 50%;
	  left:50%;
	  transform: translate(-50%,-50%);
	  background-image: url("https://quickappimg.oss-cn-shanghai.aliyuncs.com/iconImg/playmask_bg.png");
	  background-size: contain;
	  text-align: center;
	}
	.title-mask {
	  font-size: 24px;
	  color: #ffffff;
	  font-weight: bold;
	  margin-bottom: 4px;
	  margin-top: 24px;
	  display: block;
	}
	.title-tips {
	  color: #ffffff;
	  font-size: 16px;
	  margin-bottom: 20px;
	  display: block;
	}
	.tips{
		color: #ffffff;
		font-size: 12px;
		/* margin-top: 16px; */
		text-align: center;
		display: block;
		}
	.record-maskdiv > div > img {
	  width: 180px;
	  height: 49px;
	}
	.content {
		min-height: 100%;
		background-image: linear-gradient(90deg, #47127d 0, #0e0539 100%);
	}
	.contaner-box {
		height: 100%;
		background-image: url("../../../static/paly_bg.png");
		background-size: 100%;
		align-items: center;
		text-align: center;
		background-repeat: no-repeat;
		padding-top:calc(85px + env(safe-area-inset-top));
	}

	.play-title {
		width: 224px;
		height:40px;
	}

	.current_money {
		font-size: 16px;
		color: #FFFFFF;
		margin-top:6px;
		margin-bottom: 41px;
	}

	.play_tips {
		background: #FFFFFF;
		border-radius: 100px;
		background-color: rgba(255, 255, 255, .3);
		color: #ffffff;
		font-size: 12px;
		padding: 7px;
		width: 93%;
		margin-left: 16px;
		box-sizing: border-box;
	}

	.win-record {
		width: 28px;
		height: 90px;
		position: absolute;
		right: 0px;
		top: 68px;
	}

	.record-box {
		margin-top: 10px;
		width: 100%;
	}

	.record-list {
		/* justify-content: space-around; */
		width: 100%;
		margin-bottom: 6px;
		height: 355px;
		position: relative;
		overflow: hidden;
	}

	.record-item {
		float: left;
		width: 120px;
		height: 120px;
		align-items: center;
		justify-content: center;
		/* position: relative; */
		position: absolute;
	}

	.award0 {
		left: 6px;
		top: 0px;
	}

	.award1 {
		top: 0px;
		transform: translateX(-50%);
		left: 50%;
	}

	.award2 {
		top: 0px;
		right: 6px;
	}

	.award3 {
		top: 120px;
		right: 6px;
	}

	.award4 {
		top: 240px;
		right: 6px;
	}

	.award5 {
		top:240px;
		transform: translateX(-50%);
		left: 50%;
	}

	.award6 {
		top: 240px;
		left: 6px;
	}

	.award7 {
		top:120px;
		left: 6px;
	}

	.record-item>img {
		position: absolute;
		left: 0px;
		top: 0px;
		width: 120px;
		height: 120px;
	}

	.record-item-child {
		width: 100px;
		height: 100px;
		border-radius: 16px;
		align-items: flex-start;
		position: absolute;
		left: 10px;
		top: 10px;
	}

	.record-item-child>img {
		width: 100px;
		height: 100px;
		border-radius: 16px;
		position: absolute;
		left: 0px;
		top: 0px;
	}

	.record-list>.choost-btn {
		background-image: url("https://quickappimg.oss-cn-shanghai.aliyuncs.com/iconImg/record-btn.png");
		position: absolute;
		top: 130px;
		transform: translateX(-50%);
		left: 50%;
		width: 100px;
		height: 100px;
		background-size: 100%;
	}

	.record-item-child>span {
		color: #333333;
		width: 100%;
		text-align: center;
		position: absolute;
		left: 0px;
		top: 12px;
		font-size: 12px;
	}

	.record-btntext {
		width: 100%;
		margin-top: 29px;
	}

	.record-btntext>span {
		font-size: 16px;
		color: #ffffff;
		width: 100%;
		text-align: center;
		display: block;
	}

	.record-mask {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0px;
		top: 0px;
		background-color: rgba(0, 0, 0, 0.3);
		border-radius: 16px;
		z-index: 99;
	}
</style>



// WEBPACK FOOTER //
// src/view/playGames/index.vue